import React from "react"
import ContentLoader from "react-content-loader"

export default function LoadingPlaceholder() {
  return (
    <ContentLoader
      foregroundColor={"#070707"}
      backgroundColor={"#000"}
      style={{ width: "100%", height: "100%" }}
    >
      <rect x="0" y="0" width="100%" height="100%"/>
    </ContentLoader>
  )
}
